import React from 'react';
import { Table, Row, Upload, Modal, Button, Alert, Space, message, Flex, Tag, Empty, Pagination, Card } from 'antd';
import { AimOutlined, SearchOutlined, FormOutlined, ImportOutlined, SendOutlined, UploadOutlined, EditOutlined, DeleteOutlined, QrcodeOutlined} from '@ant-design/icons';
import AppIconGroup from '../../components/app-icon-group';
import SwitchShop from '../shop/switch-shop';
import { getCurrentShopId } from '../shop/get-current-shop';
import usePagination from '../../components/pagination';
import SearchButton from '../../components/search-button';
import dayjs from 'dayjs';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [shopId, setShopId] = React.useState(null);
    const [customerList, setCustomerList] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [isOpen, setIsOpen] = React.useState(false);
    const [file, setFile] = React.useState(null);
    const [customerParams, setCustomerParams] = React.useState({
        page: 1,
        pageSize: 10,
    });

    const { pagination, setTotal } = usePagination({
        onChange: (page, pageSize) => {
            console.log('page', page, pageSize);
            const params = {
                ...customerParams,
                page,
                pageSize
            };
            setCustomerParams(params);
            getCustomerList(params);
        },
    });

    // React.useEffect(() => {
    //     const fetchShopId = async () => {
    //         const id = await getCurrentShopId();
    //         setShopId(id);
    //     };
    //     fetchShopId();
    // }, []);

    const columns = [
        // {
        //     title: '客户ID',
        //     dataIndex: 'customerId',
        // },
        {
            title: '客户名称',
            dataIndex: 'username',
            render: (text, r) => <div>{text}<br/>ID：{r.customerId}</div>,
        },
        {
            title: '客户电话',
            dataIndex: 'phoneNo',
        },
        // {
        //     title: '客户ID',
        //     dataIndex: 'customerId',
        // },
        {
            title: 'openid',
            dataIndex: 'wxOpenid',
        },
        {
            title: '消费金额',
            dataIndex: 'totalConsume',
            render: (text) => <div>{text/100}</div>,
        },
        {
            title: '注册时间',
            dataIndex: 'createTime',
            render: (c) => <div>{dayjs(c).format('YYYY-MM-DD')}</div>,
        },
        {
            title: '最近消费',
            dataIndex: 'lastBuyTime',
            render: (c) => <div>{c ? dayjs(c).format('YYYY-MM-DD') : ''}</div>,
        },
        {
            title: '所在区',
            dataIndex: 'county',
            render: (text, record) => <span>{`${record.city || ''}${text || ''}`}</span>
        },
        {
            title: '备注',
            dataIndex: 'remark',
        },
        {
            title: '操作',
            fixed: 'right',
            dataIndex: 'customerId',
            width: 60,
            render: (text, record) => {
                return <Space size={'middle'}> 
                    <a onClick={() => viewQRcode(record.customerId)}><QrcodeOutlined /></a>
                    <a style={{whiteSpace: 'nowrap'}} href={`/customer/create?customerId=${record.customerId}&action=edit`}>
                        <EditOutlined />
                    </a>
                    <a style={{whiteSpace: 'nowrap'}} onClick={() => onDelete(text)}>
                        <DeleteOutlined />
                    </a>
                </Space>
            }
        }
    ];

    const viewQRcode = async (customerId) => {
        const shopId = await getCurrentShopId();
        const res = await fetch(`/api/shop/qrcode?shareCustomerId=${customerId}&shopId=${shopId}`);
        const result = await res.json();
        if (result && result.success) {
            Modal.info({
                icon: null,
                title: '客户分享二维码',
                content: <div style={{textAlign: 'center'}}><img src={`https://img.yxdj.tech/${result.data.url}`} style={{width: 200}} /></div>,
            });
        }
    }

    const onDelete = (customerId) => {
        Modal.confirm({
            title: '删除客户',
            content: '确定要删除该客户吗？',
            onOk: async () => {
                await deleteCustomer(customerId);
                getCustomerList(customerParams);
            }
        });
    }

    const deleteCustomer = async (customerId) => {
        const shopId = await getCurrentShopId();
        const res = await fetch(`/api/customer/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                shopId,
                customerId
            })
        });
        const result = await res.json();

        if (result.success) {
            message.success('删除成功');
            return result.data;
        }
        message.error(result.data);
        return null;
    }

    // 获取客户信息
    const getCustomerList = async (params) => {
        const shopId = await getCurrentShopId();
        if (!shopId) return;
        // 把params转成query字符串
        const query = Object.keys(params)
            .map((key) => `${key}=${params[key]}`)
            .join('&');
        
        const res = await fetch(`/api/customer/list?shopId=${shopId}&${query}`);
        const result = await res.json();
        if (result && result.success) {
            setCustomerList(result?.data?.rows || []);
            setTotal(result?.data.count);
        }
    }

    const onImportClick = (e) => { 
        setIsOpen(true);
        e.preventDefault();
    };

    const importCustomer = async () => { 
        const shopId = await getCurrentShopId();
        if (!file) {
            message.warning('请选择一个文件');
            return;
        }

        // 生成仅包含字母和数字的随机文件名
        const randomFileName = Array.from({ length: 8 }, () =>
            'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'[Math.floor(Math.random() * 62)]
        ).join('');
        const fileExtension = file.name.split('.').pop();
        const newFileName = `${randomFileName.toLocaleLowerCase()}.${fileExtension}`;

        // 创建新的 File 对象并替换文件名
        const renamedFile = new File([file], newFileName, {
            type: file.type,
            lastModified: file.lastModified,
        });

        const formData = new FormData();
        formData.append('shopId', shopId);
        formData.append('excelFile', renamedFile);

        setIsOpen(false);
        message.loading({content: '正在导入客户数据...', duration: 0});

        try {
            const res = await fetch('/api/customer/import?shopId='+shopId, {
                method: 'POST',
                body: formData,
            });

            const result = await res.json();
            message.destroy();

            if (result && result.success) {
                message.success(result.data);
                getCustomerList({...customerParams, shopId}); // 刷新客户列表
                setIsOpen(false); // 关闭模态框
            } else {
                message.error(result.data || '导入失败');
            }
        } catch (err) {
            console.error('导入客户出错:', err);
            message.error(err);
        }
    };

    React.useEffect(() => {
        getCustomerList({...customerParams});
    }, []);

    const handleFileChange = (info) => {
        console.log('文件改变', info);
        const file = info.file;
        setFile(file);
        if (file.status === 'done') {
          console.log('上传完成', file.response);
        }
    };

    return (
        <div>
            {/* 顶部操作区 */}
            <div className="pt-4 pb-3 mb-3">
                <SwitchShop />
                
                {/* 快捷操作 - iOS 风格图标组 */}
                <div className="mt-3">
                    <AppIconGroup 
                      items={[
                        {
                          id: 1,
                          href: '/customer/create',
                          title: '新建客户',
                          icon: <FormOutlined />,
                          color: 'from-blue-500 to-blue-600'
                        },
                        {
                          id: 2,
                          onClick: onImportClick,
                          title: '导入客户',
                          icon: <ImportOutlined />,
                          color: 'from-green-500 to-green-600'
                        },
                        {
                          id: 3,
                          href: '/promotion/sms',
                          title: '短信营销',
                          icon: <SendOutlined />,
                          color: 'from-purple-500 to-purple-600'
                        },
                        {
                          id: 4,
                          href: '/customer/discover',
                          title: '发现客户',
                          icon: <AimOutlined />,
                          color: 'from-orange-500 to-orange-600'
                        }
                      ]}
                      cols="4-4-4-4-4"
                    />
                </div>
            </div>

            {/* 标题和搜索栏 */}
            <div className="py-3 border-b border-gray-100">
                <div className="flex items-center justify-between mb-3">
                    <h2 className="admin-page-title m-0">客户列表</h2>
                    <SearchButton 
                        searchOptions={{
                            username: '用户名',
                            phoneNo: '电话',
                            customerId: '客户ID'
                        }} 
                        onSearch={(params) => getCustomerList({...customerParams, ...params, page: 1})}
                        size="small"
                        className="rounded-md active:scale-95 transition-transform text-xs"
                    >
                        <Button 
                            type="primary" 
                            icon={<SearchOutlined />} 
                            // onClick={onSearch}
                            size="small"
                            className="rounded-md active:scale-95 transition-transform text-s"
                        >
                            搜索
                        </Button>
                    </SearchButton>
                </div>

                {/* 搜索标签 */}
                <SearchButton.Tags 
                    className="mb-0"
                    onClose={(params) => {
                        let ps = {...customerParams, page: 1};
                        delete ps[params.key];
                        getCustomerList(ps);
                    }} 
                    options={{
                        username: '用户名',
                        phoneNo: '电话',
                        customerId: '客户ID'
                    }} 
                />
            </div>

            {/* 导入客户弹窗 */}
            <Modal 
                title='导入客户' 
                open={isOpen} 
                destroyOnClose={true} 
                onOk={importCustomer}
                onCancel={() => setIsOpen(false)}
                width="90%"
                style={{ maxWidth: '400px' }}
            >
                <Alert message="建议使用电脑操作" type="info" showIcon className="mb-3" />
                <Space direction="vertical" className="w-full"> 
                    <div className="text-sm">1. 下载模版，<a href='https://img.yxdj.tech/yxdj-system/excel/template.xlsx' className="text-blue-600">点击下载</a></div>
                    <div className="text-sm">2. 填写客户信息，按模版填写</div>
                    <div className="text-sm">3. 上传文件(最大为5M)</div>
                    <Upload name='excelFile'
                        customRequest={({ file }) => {
                            console.log('开始上传:', file);
                        }}
                        beforeUpload={() => false}
                        onChange={handleFileChange}
                    >
                        <Button icon={<UploadOutlined />} block>上传文件</Button>
                    </Upload>
                </Space>
            </Modal>

            {/* 客户列表 - 移动端卡片 / 桌面端表格 */}
            <div className="py-4">
                {/* 移动端：卡片列表 */}
                <div className="md:hidden space-y-3">
                    {customerList.length === 0 ? (
                        <Empty description="暂无客户数据" className="py-12" />
                    ) : (
                        customerList.map((customer) => (
                            <div key={customer.customerId} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 active:scale-[0.99] transition-transform">
                                <div className="flex justify-between items-start mb-3">
                                    <div className="flex-1 min-w-0">
                                        <div className="font-semibold text-gray-800 truncate">{customer.username}</div>
                                        <div className="text-xs text-gray-500 mt-0.5">ID: {customer.customerId}</div>
                                    </div>
                                    <div className="flex gap-2 ml-2">
                                        <div 
                                            onClick={() => viewQRcode(customer.customerId)}
                                            className="p-2 text-blue-600 active:bg-blue-50 rounded-lg transition-colors cursor-pointer"
                                        >
                                            <QrcodeOutlined />
                                        </div>
                                        <a 
                                            href={`/customer/create?customerId=${customer.customerId}&action=edit`}
                                            className="p-2 text-green-600 active:bg-green-50 rounded-lg transition-colors"
                                        >
                                            <EditOutlined />
                                        </a>
                                        <div 
                                            onClick={() => onDelete(customer.customerId)}
                                            className="p-2 text-red-600 active:bg-red-50 rounded-lg transition-colors cursor-pointer"
                                        >
                                            <DeleteOutlined />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="space-y-2 text-sm">
                                    <div className="flex justify-between">
                                        <span className="text-gray-500">电话</span>
                                        <span className="text-gray-800">{customer.phoneNo}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="text-gray-500">消费金额</span>
                                        <span className="text-red-600 font-medium">¥{(customer.totalConsume / 100).toFixed(2)}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="text-gray-500">注册时间</span>
                                        <span className="text-gray-800">{dayjs(customer.createTime).format('YYYY-MM-DD')}</span>
                                    </div>
                                    {customer.lastBuyTime && (
                                        <div className="flex justify-between">
                                            <span className="text-gray-500">最近消费</span>
                                            <span className="text-gray-800">{dayjs(customer.lastBuyTime).format('YYYY-MM-DD')}</span>
                                        </div>
                                    )}
                                    {customer.city || customer.county ? (
                                        <div className="flex justify-between">
                                            <span className="text-gray-500">所在地区</span>
                                            <span className="text-gray-800">{`${customer.city || ''}${customer.county || ''}`}</span>
                                        </div>
                                    ) : null}
                                    {customer.remark && (
                                        <div className="pt-2 border-t border-gray-100">
                                            <div className="text-gray-500 text-xs mb-1">备注</div>
                                            <div className="text-gray-700 text-xs">{customer.remark}</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {/* 桌面端：传统表格 */}
                <div className="hidden md:block">
                    <Table 
                        pagination={pagination} 
                        size='small' 
                        rowKey={'customerId'} 
                        columns={columns} 
                        dataSource={customerList} 
                        scroll={{ x: 'max-content' }} 
                    />
                </div>
            </div>

            {/* 底部分页 - 仅移动端 */}
            <div className="md:hidden px-3 pb-20">
                <Pagination 
                    current={customerParams.page}
                    pageSize={customerParams.pageSize}
                    total={pagination.total}
                    onChange={(page) => {
                        const params = {
                            ...customerParams,
                            page
                        };
                        setCustomerParams(params);
                        getCustomerList(params);
                    }}
                    simple
                    className="flex justify-center"
                />
            </div>
        </div>
    );
};